import bem from "easy-bem";
import React, { useState } from "react";

import RestrictionsPanel from "./elements/RestrictionsPanel";
import { useContentDeletion } from "./hooks/useContentDeletion";
import { useUserRestrictions } from "./hooks/useUserRestrictions";
import type { ModerationControlsProps } from "./ModerationControls.types";
import "./ModerationControls.css";

const cn = bem("moderation-controls");

const ModerationControls: React.FC<ModerationControlsProps> = ({
  personId,
  userId,
  canManage = false,
}) => {
  const [isExpanded, setIsExpanded] = useState(false);
  const { active, history } = useUserRestrictions(userId || 0);
  const { isDeleting, error, deletedCounts, deleteContent } =
    useContentDeletion(personId);

  if (!canManage) return null;

  return (
    <div className={cn()}>
      <div className={cn("toolbar")}>
        <button
          type="button"
          className={cn("toolbar-button")}
          onClick={() => setIsExpanded((v) => !v)}
        >
          Ограничения {isExpanded ? "▲" : "▼"}
          {active.length > 0 && !isExpanded && (
            <span className={cn("badge")}>{active.length}</span>
          )}
        </button>

        <button
          type="button"
          className={cn("toolbar-button", { danger: true })}
          onClick={deleteContent}
          disabled={isDeleting}
        >
          {isDeleting ? "Удаление..." : "Удалить все материалы"}
        </button>
      </div>

      {isExpanded &&
        (userId ? (
          <RestrictionsPanel
            userId={userId}
            active={active}
            history={history}
          />
        ) : (
          <div className={cn("error")}>
            У этого пользователя нет привязанного аккаунта — ограничения
            недоступны.
          </div>
        ))}

      {error && <div className={cn("error")}>{error}</div>}

      {deletedCounts && (
        <div className={cn("delete-content-summary")}>
          Удалено: проблем — {deletedCounts.problems}, решений —{" "}
          {deletedCounts.solutions}, карточек — {deletedCounts.cards},
          комментариев — {deletedCounts.comments}
        </div>
      )}
    </div>
  );
};

export default ModerationControls;
